import { Stack } from '@mui/material';
import React from 'react';
import EnabledFeatureCheck from 'components/EnabledFeatureCheck';
import FeatureFlagCheck from 'components/FeatureFlagCheck';
import { S4Feature } from 'types/api';
import { FeatureFlagId } from 'types/featureflags';
import SSOConfigStatusCard from './ConfigurationStatusCards/SSOConfigStatusCard';
import SCIMConfigurationStatusCard from './ConfigurationStatusCards/SCIMConfigurationStatusCard';
import JITConfigurationStatusCard from './ConfigurationStatusCards/JITConfigurationStatusCard';
import XAAConfigurationStatusCard from './ConfigurationStatusCards/XAAConfigurationStatusCard';

const ConfigurationsStatus: React.FC = () => (
	<Stack direction="row" gap={3} flexWrap="wrap">
		<EnabledFeatureCheck feature={S4Feature.Sso}>
			<SSOConfigStatusCard />
		</EnabledFeatureCheck>
		<EnabledFeatureCheck feature={S4Feature.Scim}>
			<SCIMConfigurationStatusCard />
		</EnabledFeatureCheck>
		<EnabledFeatureCheck feature={S4Feature.Xaa}>
			<XAAConfigurationStatusCard />
		</EnabledFeatureCheck>
		<EnabledFeatureCheck feature={S4Feature.JitGuide}>
			<FeatureFlagCheck flag={FeatureFlagId.JIT_CARD}>
				<JITConfigurationStatusCard />
			</FeatureFlagCheck>
		</EnabledFeatureCheck>
	</Stack>
);

export default ConfigurationsStatus;
